// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const ServiceOrdersPage = lazy(() => import('./pages/ServiceOrdersPage'));
const TechnicianSchedulingPage = lazy(() => import('./pages/TechnicianSchedulingPage'));
const RouteOptimizationPage = lazy(() => import('./pages/RouteOptimizationPage'));
const MobileFieldAppPage = lazy(() => import('./pages/MobileFieldAppPage'));
const LiveTrackingPage = lazy(() => import('./pages/LiveTrackingPage'));
const PartsPage = lazy(() => import('./pages/PartsPage'));
const ServiceHistoryPage = lazy(() => import('./pages/ServiceHistoryPage'));
const PreventiveMaintenancePage = lazy(() => import('./pages/PreventiveMaintenancePage'));
const SlaPage = lazy(() => import('./pages/SlaPage'));

export const FieldserviceRoutes: RouteObject = {
  path: 'fieldservice',
  element: <ModuleGuard moduleId="operations.fieldservice" />,
  children: [
    { path: 'service-orders', element: <ServiceOrdersPage />, handle: { crumb: 'Service Orders' } },
    { path: 'technician-scheduling', element: <TechnicianSchedulingPage />, handle: { crumb: 'Technician Scheduling' } },
    { path: 'route-optimization', element: <RouteOptimizationPage />, handle: { crumb: 'Route Optimization' } },
    { path: 'mobile-field-app', element: <MobileFieldAppPage />, handle: { crumb: 'Mobile Field App' } },
    { path: 'live-tracking', element: <LiveTrackingPage />, handle: { crumb: 'Live Tracking' } },
    { path: 'parts', element: <PartsPage />, handle: { crumb: 'Parts' } },
    { path: 'service-history', element: <ServiceHistoryPage />, handle: { crumb: 'Service History' } },
    { path: 'preventive-maintenance', element: <PreventiveMaintenancePage />, handle: { crumb: 'Preventive Maintenance' } },
    { path: 'sla', element: <SlaPage />, handle: { crumb: 'SLA' } },
  ],
};
